import React from 'react';
import './SocialBar.css';

function SocialBar({ hoverPhone }) {
  return (
    <div className="social-bar">
      <a href="https://wa.me/905331418202" target="_blank" rel="noreferrer" aria-label="WhatsApp">
        <i className="fab fa-whatsapp"></i>
      </a>

      <a href="tel:+905331418202" aria-label="Bizi Arayın">
        <i className={`fas fa-phone-alt ${hoverPhone ? 'blink' : ''}`}></i>
      </a>

      <a href="https://www.instagram.com/group_erya" target="_blank" rel="noreferrer" aria-label="Instagram">
        <i className="fab fa-instagram"></i>
      </a>

      <a
        href="https://www.google.com/maps/place/Çetinler+Zanaat/@41.1467987,28.9214139,17.11z/data=!4m15!1m8!3m7!1s0x14cab3bb06861def:0x5867f886b7c2ddc4!2sMithatpaşa+Mh.,+Selanik+Blv.+No:3,+34075+Eyüpsultan%2Fİstanbul!3b1!8m2!3d41.146853!4d28.921366!16s%2Fg%2F11fl9gll31!3m5!1s0x14cab35bccb63b7b:0x364f2a8524544811!8m2!3d41.1465361!4d28.9197486!16s%2Fg%2F11jsnvbw_x?entry=ttu"
        target="_blank"
        rel="noopener noreferrer"
        title="Adres"
      >
        <i className="fas fa-map-marker-alt"></i>
      </a>
    </div>
  );
}

export default SocialBar;
